import { call, put, takeLatest, delay } from 'redux-saga/effects';

import api from '~/services/api';
import { getCookies, getCookiesSuccess, getCookiesFailure } from '.';
import { selectCookies } from './selectors';

export default function* rootSaga() {
	yield takeLatest(getCookies, getCookiesSaga);
}

function* getCookiesSaga({ payload }) {
	try {
		yield delay(500);
		const { data } = yield call(api.get, `/cookies/${payload}`);
		yield put(getCookiesSuccess(selectCookies(data.data)));
	} catch (error) {
		yield put(getCookiesFailure(error.response.data.error));
	}
}
